import PropTypes from 'prop-types'
import './paginacion.css'

const MAX_PAGINAS_VISIBLES = 5
const PAGINAS_IZQUIERDA = 2

export const Paginacion = ({
  totalPaginas,
  paginaActual,
  onCambioPagina,
  itemsPorPagina,
  onCambioItemsPorPagina
}) => {
  const handleClick = (numPagina) => {
    if (numPagina !== paginaActual) {
      onCambioPagina(numPagina)
    }
  }

  const getPaginasVisibles = () => {
    let start = Math.max(
      1,
      paginaActual - Math.floor(MAX_PAGINAS_VISIBLES / PAGINAS_IZQUIERDA)
    )

    let end = start + MAX_PAGINAS_VISIBLES - 1

    if (end > totalPaginas) {
      end = totalPaginas
      start = Math.max(1, end - MAX_PAGINAS_VISIBLES + 1)
    }

    return Array.from({ length: end - start + 1 }, (_, i) => start + i)
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '20px 0',
        gap: '10px',
        flexWrap: 'wrap'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <label style={{ fontSize: '14px', color: '#555' }}>Registros por página:</label>
        <select
          value={itemsPorPagina}
          onChange={(e) => onCambioItemsPorPagina(Number(e.target.value))}
          style={{
            padding: '6px 10px',
            borderRadius: '6px',
            border: '1px solid #ccc',
            cursor: 'pointer'
          }}
        >
          <option value={15}>15</option>
          <option value={30}>30</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
      </div>
      <button
        onClick={() => handleClick(paginaActual - 1)}
        disabled={paginaActual === 1}
        className={paginaActual === 1 ? 'disabledBtn' : 'baseBtn'}
        title="Página anterior"
      >
        <i className="fa fa-chevron-left" />
      </button>
      {getPaginasVisibles().map((num) => (
        <button
          key={num}
          onClick={() => handleClick(num)}
          className={num === paginaActual ? 'activeBtn' : 'baseBtn'}
        >
          {num}
        </button>
      ))}
      <button
        onClick={() => handleClick(paginaActual + 1)}
        disabled={paginaActual === totalPaginas}
        className={paginaActual === totalPaginas ? 'disabledBtn' : 'baseBtn'}
        title="Página siguiente"
      >
        <i className="fa fa-chevron-right" />
      </button>

      <button
        onClick={() => handleClick(totalPaginas)}
        disabled={paginaActual === totalPaginas}
        className={paginaActual === totalPaginas ? 'disabledBtn' : 'baseBtn'}
        title="Última página"
      >
        ⏭
      </button>
    </div>
  )
}

Paginacion.propTypes = {
  totalPaginas: PropTypes.number.isRequired,
  paginaActual: PropTypes.number.isRequired,
  onCambioPagina: PropTypes.func.isRequired,
  itemsPorPagina: PropTypes.number.isRequired,
  onCambioItemsPorPagina: PropTypes.func.isRequired
}
